/**
 * Zod schemas for Business Config edit forms.
 *
 * Angular parity:
 * - Screening: `section_label` required; at least one sub-point with non-empty
 *   rich-text. Per-field required + a submit guard "Section and message are
 *   required." (rich-text emptiness is checked in the modal via `isRichTextEmpty`).
 * - Reimbursement note: `note_text` required.
 */

import { z } from 'zod'

export const screeningSubPointSchema = z.object({
  message_text: z.string(),
  allow_personalized_note: z.boolean(),
})

export const screeningFormSchema = z.object({
  section_label: z.string().min(1, 'Section Label is required'),
  messages: z.array(screeningSubPointSchema).min(1),
})

export type ScreeningFormValues = z.infer<typeof screeningFormSchema>

export const reimbursementNoteFormSchema = z.object({
  note_text: z.string().min(1, 'Note Text is required'),
})

export type ReimbursementNoteFormValues = z.infer<typeof reimbursementNoteFormSchema>
